import { HomeOutlined } from "@ant-design/icons";

export const RoomDetails = (props) => {
  const { selectedBooking } = props;
  return (
    <div
      style={{
        backgroundColor: "#fff",
        padding: "20px",
        borderRadius: "8px",
        boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "10px",
          marginBottom: "15px",
        }}
      >
        <HomeOutlined style={{ fontSize: "20px", color: "#1890ff" }} />
        <h3 style={{ margin: 0, color: "#333" }}>Room Details</h3>
      </div>
      {selectedBooking.rooms && selectedBooking.rooms.length > 0 ? (
        selectedBooking.rooms.map((room, index) => (
          <div
            key={room._id || index}
            style={{
              marginBottom: "15px",
              padding: "15px",
              border: "1px solid #e8e8e8",
              borderRadius: "6px",
              backgroundColor: "#fafafa",
            }}
          >
            <h4 style={{ margin: 0, color: "#1890ff" }}>Room {index + 1}</h4>
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
                gap: "10px",
                marginTop: "10px",
              }}
            >
              <p style={{ margin: 0 }}>
                <strong>Room Type:</strong>{" "}
                <span style={{ color: "#555" }}>{room.room || "N/A"}</span>
              </p>
              <p style={{ margin: 0 }}>
                <strong>Rate Plan:</strong>{" "}
                <span style={{ color: "#555" }}>
                  {room.ratePlanName || "N/A"}
                </span>
              </p>
              <p style={{ margin: 0 }}>
                <strong>Rate:</strong>{" "}
                <span style={{ color: "#555" }}>
                  {room.ratePlanRate || "N/A"}
                </span>
              </p>
              <p style={{ margin: 0 }}>
                <strong>Number of Rooms:</strong>{" "}
                <span style={{ color: "#555" }}>
                  {room.numberOfRooms || "N/A"}
                </span>
              </p>
              <p style={{ margin: 0 }}>
                <strong>Adults:</strong>{" "}
                <span style={{ color: "#555" }}>{room.adults || "N/A"}</span>
              </p>
              <p style={{ margin: 0 }}>
                <strong>Children:</strong>{" "}
                <span style={{ color: "#555" }}>{room.children || "N/A"}</span>
              </p>
              <p style={{ margin: 0 }}>
                <strong>Extra Bed:</strong>{" "}
                <span style={{ color: "#555" }}>
                  {room.extraBed ? "Yes" : "No"}
                </span>
              </p>
              <p style={{ margin: 0 }}>
                <strong>Meal Plan:</strong>{" "}
                <span style={{ color: "#555" }}>{room.mealPlan || "N/A"}</span>
              </p>
              <p style={{ margin: 0 }}>
                <strong>Cancellation Policy:</strong>{" "}
                <span style={{ color: "#555" }}>
                  {room.cancellationPolicy || "N/A"}
                </span>
              </p>
              {room.promotionsApplied &&
                room.promotionsApplied[selectedBooking.fromdate] && (
                  <p style={{ margin: 0 }}>
                    <strong>Promotion Applied:</strong>
                    <span style={{ color: "#555" }}>
                      {room.promotionsApplied[selectedBooking.fromdate]
                        .promotionName || "N/A"}
                    </span>
                  </p>
                )}
            </div>
          </div>
        ))
      ) : (
        <p style={{ color: "#888" }}>No room details available.</p>
      )}
    </div>
  );
};
